import { useLocation } from 'react-router-dom';

import { EMPTY_ARRAY } from '@e-socna/empty';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { createDocumentEditorReducer } from '../reducers';
import type { DocumentEditorCmp_TemplateDependency } from '../queries/one-template-dependency.query';
import type { Editable } from '../types/editable.type';
import type { Getters } from '../types/props.type';

interface Params<E extends Editable> {
  readonly initialEditable: E;
  readonly getters: Getters<E>;
  readonly templateDependencies?: readonly DocumentEditorCmp_TemplateDependency[];
}

export const useDocumentEditorReducer = <E extends Editable>({
  initialEditable,
  getters,
  templateDependencies,
}: Readonly<Params<E>>) => {
  const { pathname: currentPath } = useLocation();

  const { genericStatuses, contentOriginsCodeMap } = useReferencesContext();

  return createDocumentEditorReducer({
    initialEditable,
    getters,
    templateDependencies: templateDependencies ?? EMPTY_ARRAY,
    contentOriginsCodeMap,
    genericStatuses,
    currentPath,
  });
};
